
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mdiClose, mdiPencil } from '@mdi/js';
import { LineupModel } from '@/models/lineup';
import { VuetifyMixin, BAIconsMixin, AppHostnameMixin } from '@/mixins';
import Lineup from './Lineup.vue';
import { TeamModel } from '@/models/team';
import { ContextMenuItem } from '@/../types/interfaces';

@Component({
	components: { Lineup },
})
export default class LineupCard extends Mixins(VuetifyMixin, BAIconsMixin, AppHostnameMixin) {

	@Prop({ required: true }) team: TeamModel;
	@Prop({ default: null, required: true }) lineup: LineupModel;
	@Prop({ type: Boolean, default: false }) share: boolean;
	@Prop({ type: Boolean, default: false }) disabled: boolean;
	updateShare(value: boolean): void{
		this.share = value;
		this.$emit('update:share', value);
	}

	get Title(): string{
		if(!this.lineup) return '';
		return this.lineup.name;
	}

	get ContextMenuItems(): ContextMenuItem[]{
		return [
			{
				text: 'Edit Lineup',
				click: () => {
					this.$emit('switch');
				},
				icon: mdiPencil,
			},
			{
				text: 'Clear Lineup',
				click: () => {
					this.$emit('clear');
				},
				icon: mdiClose,
			}
		];
	}

}
